import axios from "axios";

const cacheGet = (key) => (typeof sessionStorage !== "undefined" ? sessionStorage.getItem(key) : null);
const cacheSet = (key, value) => { try { if (typeof sessionStorage !== "undefined") sessionStorage.setItem(key, value !== undefined && value !== null ? String(value) : ""); } catch (e) {} };
const cacheClear = () => { try { if (typeof sessionStorage !== "undefined") sessionStorage.clear(); } catch (e) {} };

let BASE_DOMAIN = "https://histolabapi.emedhub.in/" ;
// let BASE_DOMAIN = "https://beta.histoapi.emedhub.in/" ;
const App_Version = 1.1;
const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
export const APP_Version_Label = "v1";
export const APP_Support_Label = "Call us: +91 80641 24272"

export const getBaseUrl = () => {
  return BASE_DOMAIN;
}

class RestAPIService {

  getBaseDomain = (URL) => {
    return BASE_DOMAIN;
  }

  getAll = async (URL) => {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error("No connection available"));
    }
    try {
      const response = await axios.create({
        baseURL: this.getBaseDomain(URL),
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + cacheGet("AccessToken"),
          'ngrok-skip-browser-warning': 'true',
          // "USEHOST": "replica_1"
        }
      }).get("/" + URL);

      const { data } = response;

      if (data && typeof data === "object" && "version" in data && data.version !== App_Version) {
        cacheClear();
        setTimeout(() => {
          window.location.href = window.location.origin;
        }, 1000);
        return response;
      }
      if (data && typeof data === "object") {
        if (data?.show_sms_alert) {
          cacheSet("show_sms_alert", true);
        } else {
          cacheSet("show_sms_alert", false);
        }
        if (data?.show_whatsapp_alert) {
          cacheSet("show_whatsapp_alert", true);
        } else {
          cacheSet("show_whatsapp_alert", false);
        }
        if (data?.subscription_alert_message) {
          cacheSet("subscription_alert_message", data?.subscription_alert_message);
        } else {
          cacheSet("subscription_alert_message", "");
        }
      }

      return response;
    } catch (error) {
      if (error?.response && error?.response?.status === 401) {
        // comment for time zone
        // cacheClear();
        // setTimeout(() => {
        //   window.location.href = window.location.origin
        // }, 1000);
      }
      return Promise.reject(error);
    }
  };

  GetWithoutReplica = async (URL) => {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error("No connection available"));
    }
    try {
      const response = await axios.create({
        baseURL: BASE_DOMAIN,
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + cacheGet("AccessToken"),
        }
      }).get("/" + URL);

      const { data } = response;

      if (data?.version !== App_Version && typeof data === "object") {
        cacheClear();
        setTimeout(() => {
          window.location.href = window.location.origin;
        }, 1000);
        return response;
      }
      if (data?.show_sms_alert) {
        cacheSet("show_sms_alert", true);
      } else {
        cacheSet("show_sms_alert", false);
      }
      if (data?.show_whatsapp_alert) {
        cacheSet("show_whatsapp_alert", true);
      } else {
        cacheSet("show_whatsapp_alert", false);
      }
      if (data?.subscription_alert_message) {
        cacheSet("subscription_alert_message", data?.subscription_alert_message);
      } else {
        cacheSet("subscription_alert_message", "");
      }

      return response;
    } catch (error) {
      if (error?.response && error?.response?.status === 401) {
        // comment for time zone
        // cacheClear();
        // setTimeout(() => {
        //   window.location.href = window.location.origin
        // }, 1000);
      }
      return Promise.reject(error);
    }
  };

  getAllTwo = async (URL) => {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No connection available'));
    }
    try {
      const response = await axios.create({
        baseURL: this.getBaseDomain(URL),
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + cacheGet("AccessToken")
        }
      }).get("/" + URL);
      const { data } = response;
      if (data?.version !== App_Version && typeof data === "object") {
        cacheClear();
        setTimeout(() => {
          window.location.href = window.location.origin;
        }, 1000);
        return response;
      }
      if (data?.show_sms_alert) {
        cacheSet("show_sms_alert", true);
      } else {
        cacheSet("show_sms_alert", false);
      }
      if (data?.show_whatsapp_alert) {
        cacheSet("show_whatsapp_alert", true);
      } else {
        cacheSet("show_whatsapp_alert", false);
      }
      if (data?.subscription_alert_message) {
        cacheSet("subscription_alert_message", data?.subscription_alert_message);
      } else {
        cacheSet("subscription_alert_message", "");
      }
      return response;
    } catch (error) {
      if (error?.response && error?.response?.status === 401) {
        // comment for time zone
        // cacheClear();
        // setTimeout(() => {
        //   window.location.href = window.location.origin
        // }, 1000);
      }
      return Promise.reject(error);
    }
  }

  getAllPrint = async (URL) => {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No connection available'));
    }
    try {
      const response = await axios.create({
        baseURL: this.getBaseDomain(URL),
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + cacheGet("AccessToken")
        }
      }).get("/" + URL);
      const { data } = response;
      if (data?.version !== App_Version && typeof data === "object") {
        cacheClear();
        setTimeout(() => {
          window.location.href = window.location.origin;
        }, 1000);
        return response;
      }
      if (data?.show_sms_alert) {
        cacheSet("show_sms_alert", true);
      } else {
        cacheSet("show_sms_alert", false);
      }
      if (data?.show_whatsapp_alert) {
        cacheSet("show_whatsapp_alert", true);
      } else {
        cacheSet("show_whatsapp_alert", false);
      }
      if (data?.subscription_alert_message) {
        cacheSet("subscription_alert_message", data?.subscription_alert_message);
      } else {
        cacheSet("subscription_alert_message", "");
      }
      return response;
    } catch (error) {
      if (error?.response && error?.response?.status === 401) {
        // comment for time zone
        // cacheClear();
        // setTimeout(() => {
        //   window.location.href = window.location.origin
        // }, 1000);
      }
      return Promise.reject(error);
    }
  }

  get(id, URL) {
    return axios.create({
      baseURL: this.getBaseDomain(URL),
      headers: {
        "Content-type": "application/json",
        "Authorization": "Token " + cacheGet("AccessToken"),
        "USEHOST": "replica_1"
      }
    }).get(`/${URL}/${id}`);
  }

  getListbyData(id, data, URL) {
    return axios.create({
      baseURL: this.getBaseDomain(URL),
      headers: {
        "Content-type": "application/json",
        "Authorization": "Token " + cacheGet("AccessToken"),
        "USEHOST": "replica_1"
      }
    }).get(`${URL}/${id}`, data);
  }

  create = async (data, URL) => {
    let Token = cacheGet("AccessToken") ? cacheGet("AccessToken") : cacheGet("LoginAuthToken");

    if (!window.navigator.onLine) {
      return Promise.reject(new Error("No internet connection available"));
    }

    try {
      const response = await axios.create({
        baseURL: this.getBaseDomain(URL),
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + Token,
          "X-Client-Timezone": timeZone,
        }
      }).post("/" + URL, data);

      return response;
    } catch (error) {
      if (error?.response && error?.response?.status === 401) {
        // comment for time zone
        // cacheClear();
        // setTimeout(() => {
        //   window.location.href = window.location.origin
        // }, 1000);
      }
      return Promise.reject(error);
    }
  }

  abhaVerifyDownload(data, URL) {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No internet connection available'));
    } else {
      return axios.create({
        baseURL: this.getBaseDomain(URL),
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + cacheGet("AccessToken"),
          "X-Client-Timezone": timeZone,
        },
        responseType: 'arraybuffer'
      }).post("/" + URL, data, {responseType: 'arraybuffer'});
    }
  }

  update = async (id, data, URL) => {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error("No internet connection available"));
    }

    try {
      const response = await axios.create({
        baseURL: this.getBaseDomain(URL),
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + cacheGet("AccessToken"),
          "X-Client-Timezone": timeZone,
        }
      }).put(`/${URL}${id}/`, data);

      return response;
    } catch (error) {
      if (error?.response && error?.response?.status === 401) {
        // comment for time zone
        // cacheClear();
        // setTimeout(() => {
        //   window.location.href = window.location.origin
        // }, 1000);
      }
      return Promise.reject(error);
    }
  };

  delete(URL, Data) {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No internet connection available'));
    } else {
      return axios.create({
        baseURL: this.getBaseDomain(URL),
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + cacheGet("AccessToken")
        }
      }).delete("/" + URL, { data: Data });
    }
  }

  deleteAll(URL) {
    return axios.create({
      baseURL: this.getBaseDomain(URL),
      headers: {
        "Content-type": "application/json",
        "Authorization": "Token " + cacheGet("AccessToken")
      }
    }).delete(`/${URL}`);
  }

  findByTitle(title, URL) {
    return axios.create({
      baseURL: this.getBaseDomain(URL),
      headers: {
        "Content-type": "application/json",
        "Authorization": "Token " + cacheGet("AccessToken"),
        "USEHOST": "replica_1",
        "X-Client-Timezone": timeZone,
      }
    }).get(`/${URL}?title=${title}`);
  }

  updateWithOutId = async (data, URL) => {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error("No internet connection available"));
    }

    try {
      const response = await axios.create({
        baseURL: this.getBaseDomain(URL),
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + cacheGet("AccessToken"),
          "X-Client-Timezone": timeZone,
        }
      }).put(`/${URL}`, data);

      return response;
    } catch (error) {
      if (error?.response && error?.response?.status === 401) {
        // comment for time zone
        // cacheClear();
        // setTimeout(() => {
        //   window.location.href = window.location.origin
        // }, 1000);
      }
      return Promise.reject(error);
    }
  }
  patch(data, URL) {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No internet connection available'));
    } else {
      return axios.create({
        baseURL: this.getBaseDomain(URL),
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + cacheGet("AccessToken"),
          "X-Client-Timezone": timeZone,
        }
      }).patch(`/${URL}`, data);
    }
  }

  /** Post with FormData (no Content-Type so axios sets multipart/form-data). */
  postFormData(data, URL) {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error("No internet connection available"));
    }
    const Token = cacheGet("AccessToken") || cacheGet("LoginAuthToken");
    const headers = {
      Authorization: "Token " + Token,
      "X-Client-Timezone": timeZone,
    };
    return axios.create({
      baseURL: this.getBaseDomain(URL),
      headers,
    }).post("/" + URL, data);
  }

  /** Patch with FormData (no Content-Type so axios sets multipart/form-data). */
  patchFormData(data, URL) {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No internet connection available'));
    }
    const headers = {
      "Authorization": "Token " + cacheGet("AccessToken"),
      "X-Client-Timezone": timeZone,
    };
    return axios.create({
      baseURL: this.getBaseDomain(URL),
      headers,
    }).patch(`/${URL}`, data);
  }
  excelGetAccReport(URL) {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No internet connection available'));
    } else {
      return axios.create({
        baseURL: this.getBaseDomain(URL),
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + cacheGet("AccessToken"),
        },
        responseType: 'blob'
      }).get("/" + URL);
    }
  }
  excelGet(URL) {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No internet connection available'));
    } else {
      return axios.create({
        baseURL: this.getBaseDomain(URL),
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + cacheGet("AccessToken"),
          "USEHOST": "replica_1"
        },
        responseType: 'blob'
      }).get("/" + URL);
    }
  }
  PrintPDF(URL) {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No internet connection available'));
    } else {
      return axios.create({
        baseURL: this.getBaseDomain(URL),
        headers: {
          "Content-type": "application/pdf",
          "Authorization": "Token " + cacheGet("AccessToken")
        },
        responseType: 'blob',
      }).get("/" + URL);
    }
  }

  LoginAuthGetModules = async (URL) => {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error("No internet connection available"));
    }

    try {
      const response = await axios.create({
        baseURL: this.getBaseDomain(URL),
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + cacheGet("LoginAuthToken"),
        },
      }).get("/" + URL);

      const { data } = response;
      if (data?.version !== App_Version && typeof data === "object") {
        cacheClear();
        setTimeout(() => {
          window.location.href = window.location.origin;
        }, 1000);
        return response;
      }
      return response;
    } catch (error) {
      if (error?.response && error?.response?.status === 401) {
        // comment for time zone
        // cacheClear();
        // setTimeout(() => {
        //   window.location.href = window.location.origin
        // }, 1000);
      }
      return Promise.reject(error);
    }
  };


  OPTICAL_CRM_POST(data) {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No internet connection available'));
    } else {
      return axios.create({
        baseURL: "https://api.opticalcrm.com",
        headers: {
          "Content-type": "application/json",
          "Token": cacheGet("OPTICAL_CRM_API_TOKEN")
        }
      }).post("/sales_details.php", data);
    }
  }

  OPTICAL_CRM_POST_WITH_URL(url, data) {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No internet connection available'));
    } else {
      return axios.create({
        baseURL: "https://api.opticalcrm.com",
        headers: {
          "Content-type": "application/json",
          "Token": cacheGet("OPTICAL_CRM_API_TOKEN")
        }
      }).post("/" + url , data);
    }
  }

  OPTICAL_CRM_GET(URL) {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No internet connection available'));
    } else {
      return axios.create({
        baseURL: "https://api.opticalcrm.com",
        headers: {
          "Content-type": "application/json",
          "Token": cacheGet("OPTICAL_CRM_API_TOKEN")
        }
      }).get("/" + URL);
    }
  }

  QR_REGISTRATION_POST_WITH_URL(url, data){
    if (!window.navigator.onLine) {
      return Promise.reject(new Error('No internet connection available'));
    } else {
      return axios.create({
        baseURL: this.getBaseDomain(url),
        headers: {
          "Content-type": "application/json",
        }
      }).post("/" + url , data);
    }
  }

  getAllForTeleEndCall = async (URL, Token) => {
    if (!window.navigator.onLine) {
      return Promise.reject(new Error("No connection available"));
    }
    try {

      const response = await axios.create({
        baseURL: BASE_DOMAIN,
        headers: {
          "Content-type": "application/json",
          "Authorization": "Token " + (cacheGet("AccessToken") || Token),
          // "USEHOST": "replica_1"
        }
      }).get("/" + URL);

      const { data } = response;

      if (data?.version !== App_Version && typeof data === "object") {
        cacheClear();
        setTimeout(() => {
          window.location.href = window.location.origin;
        }, 1000);
        return response;
      }
      if (data?.show_sms_alert) {
        cacheSet("show_sms_alert", true);
      } else {
        cacheSet("show_sms_alert", false);
      }
      if (data?.show_whatsapp_alert) {
        cacheSet("show_whatsapp_alert", true);
      } else {
        cacheSet("show_whatsapp_alert", false);
      }
      if (data?.subscription_alert_message) {
        cacheSet("subscription_alert_message", data?.subscription_alert_message);
      } else {
        cacheSet("subscription_alert_message", "");
      }

      return response;
    } catch (error) {
      if (error?.response && error?.response?.status === 401) {
        // comment for time zone
        // cacheClear();
        // setTimeout(() => {
        //   window.location.href = window.location.origin
        // }, 1000);
      }
      return Promise.reject(error);
    }
  };

}

const restAPIService = new RestAPIService();
export default restAPIService;
